var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClosetMode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "824px",
    height: "824px",
    viewBox: "0 0 824 824",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "closet_mode") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "closet_mode",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(284.000000, 284.000000)",
    stroke: "#222222"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256,128 C256,57.3091701 198.69083,0 128,0 C57.3091701,0 0,57.3091701 0,128 C0,198.69083 57.3091701,256 128,256 C198.69083,256 256,198.69083 256,128 Z",
    id: "changeStroke",
    strokeWidth: 10,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,105.890909 L128,117.527273 L59.4938623,161.695704 C56.2530925,163.785147 55.3197583,168.106139 57.409202,171.346909 C58.6947276,173.340785 60.9047689,174.545455 63.2771347,174.545455 L192.722865,174.545455 C196.578817,174.545455 199.704683,171.419588 199.704683,167.563636 C199.704683,165.191271 198.500014,162.981229 196.506138,161.695704 L128,117.527273 L128,117.527273",
    id: "changeStroke",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.8,91.9272727 C140.8,84.8580279 135.069245,79.1272727 128,79.1272727 C120.930755,79.1272727 115.2,84.8580279 115.2,91.9272727 C115.2,98.9965175 120.930755,104.727273 128,104.727273",
    id: "changeStroke",
    strokeWidth: 8
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosetMode);
export default __webpack_public_path__ + "static/media/closet_mode.d4c64824a935710e0c47327e8b2d765c.svg";
export { ForwardRef as ReactComponent };